import { decodeJwtObject } from './base64'

export function login(data) {
    let obj = decodeJwtObject(data.accessToken)

    localStorage.setItem('accessToken', data.accessToken)
    localStorage.setItem('usuarioId', obj.usuario.id.toString())
    localStorage.setItem('pessoaId', obj.usuario.id_pessoa.toString())
}

export function logout() {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('usuarioId')
    localStorage.removeItem('pessoaId')
}



// WEBPACK FOOTER //
// ./src/common/auth.js